import React          from 'react';
import SplitViewStore from '@widesk-ui/stores/SplitViewStore';

type SplitViewContextType = { splitViewStore?: SplitViewStore; }

const SplitViewContext = React.createContext<SplitViewContextType>({ splitViewStore: undefined });

export default SplitViewContext;
